import { Col, Row, Accordion } from "react-bootstrap";
import parse from "html-react-parser";
import "./App.css";
import InlineSVG from "svg-inline-react";
import { VrSvg } from "./SvgJs/Vr-source";
import { ClockIcon } from "./FilterIcons";
import GalleryContainer from "./GalleryContainer";
import { formatSchedule, getPlaceSchedule } from "./utils/restauration";

const hasContent = (value) => value != null && value !== "";

// Le champ CMS commence souvent par « Horaires d'ouverture : » ; l'encadré
// portant déjà ce titre, on retire l'étiquette en tête (et le retour à la
// ligne ou le paragraphe vide qu'elle laisse derrière elle) sans toucher aux
// balises ouvrantes qui l'entourent.
const stripHoursLabel = (html) =>
    html
        .replace(
            /^((?:\s*<[^/][^>]*>)*)\s*horaires?\s*d\s*['’`]?\s*ouverture\s*:?\s*(?:<br\s*\/?>\s*)*/i,
            "$1"
        )
        .replace(/<(p|h\d)[^>]*>(?:\s|&nbsp;|&zwj;|‍)*<\/\1>/gi, "");

function ExtendedCard({ place, isMobile }) {
    /* Quand le CMS porte la grille hebdomadaire au format strict, on la met en
       forme plutôt que d'aligner sept lignes identiques. Les autres fiches —
       chambres, salles — gardent leur texte libre : la liste est vide et le
       rendu d'origine reprend la main. */
    const schedule = place.length > 0 ? formatSchedule(getPlaceSchedule(place[0])) : [];

    return (
        <>
            {place.length > 0 ? (
                <div
                    className={ false === isMobile ? "imgExtendDesktop" : "imgExtendMobile px-0" }
                >
                    <Col>
                        <Row>
                            <div className="extendedBody">
                                <h1>{parse(place[0].name || "")}</h1>
                                <h5 className="subtitle text-uppercase">
                                    {parse(place[0].baseline || "")}
                                    <br />
                                </h5>
                                <div className="MediaWrapper">
                                    {place[0].hasOwnProperty("media") && place[0]["galerie"]?.length > 0 ? (
                                        <GalleryContainer frontImg={place[0].media} gallery={place[0]["galerie"]} />
                                    ) : place[0].hasOwnProperty("media") ? (
                                        <img
                                            className="media-header"
                                            alt="rendu"
                                            src={place[0].media.url}
                                        />
                                    ) : (
                                        <br />
                                    )}
                                    {place[0].hasOwnProperty("media-video") && (
                                        <div className="VideoWrapper">
                                            {parse(place[0]["media-video"]?.metadata?.html || "")}
                                        </div>
                                    )}
                                </div>

                                {place[0]["lien-vr"] && (
                                    <div className="placesTools">
                                        <a
                                            className="vrlink"
                                            href={place[0]["lien-vr"]}
                                            target="_blank"
                                            rel="noreferrer"
                                        >
                                            <InlineSVG src={VrSvg} />
                                            <span>Vue 360° </span>
                                        </a>
                                    </div>
                                )}

                                {/* Les horaires sortent des « infos pratiques » : c'est
                                    l'information la plus consultée, elle se lit sans avoir
                                    à ouvrir l'accordéon. */}
                                {hasContent(place[0]["horaires-d-ouverture"]) && (
                                    <div className="hours-card">
                                        <div className="hours-card-head">
                                            <ClockIcon className="hours-card-icon" />
                                            <span>Horaires d'ouverture</span>
                                        </div>
                                        <div className="hours-card-body">
                                            {schedule.length !== 0 ? (
                                                <ul className="hours-card-week">
                                                    {schedule.map(({ days, hours }) => (
                                                        <li key={days}>
                                                            <span className="hours-card-days">
                                                                {days}
                                                            </span>
                                                            <span className="hours-card-hours">
                                                                {hours}
                                                            </span>
                                                        </li>
                                                    ))}
                                                </ul>
                                            ) : (
                                                parse(stripHoursLabel(place[0]["horaires-d-ouverture"]))
                                            )}
                                        </div>
                                    </div>
                                )}

                                <div>
                                    {hasContent(place[0]["informations-techniques"]) ? (
                                        <>
                                            <Accordion
                                                className="accordion-div"
                                                flush
                                            >
                                                <Accordion.Item eventKey="0">
                                                    <Accordion.Header className="collapse-head">
                                                        Infos pratiques
                                                    </Accordion.Header>
                                                    <Accordion.Body className="collapse-bot">
                                                        {parse(place[0]["informations-techniques"] || "")}
                                                    </Accordion.Body>
                                                </Accordion.Item>
                                            </Accordion>
                                            <br />
                                        </>
                                    ) : (
                                        <></>
                                    )}
                                </div>

                                <div>{parse(place[0].description || "")}</div>
                            </div>
                        </Row>
                    </Col>
                </div>
            ) : (
                <></>
            )}
        </>
    );
}

export default ExtendedCard;
